import React from 'react';
import { Smartphone } from 'lucide-react';
import { t } from '../../i18n';

const ACCENT = '#3fced1';

export const APP_STORE_URL = 'https://apps.apple.com/de/app/dartcloud/id1521584889';
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=de.dartcloudapp.app';

/** App-Download Call-to-Action – Port der Flutter app_download_cta_section. */
const AppDownloadCta: React.FC = () => {
  return (
    <section className="mx-auto max-w-7xl px-4 py-12 sm:px-6">
      <div className="relative overflow-hidden rounded-3xl border border-zinc-800 bg-zinc-900 p-8 shadow-xl shadow-black/20 sm:p-12">
        {/* Akzent-Glow (funktioniert in Dark & Light) */}
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0"
          style={{
            background:
              t('web.component.app-download-cta.radial-gradient-80-120-at'),
          }}
        />
        <div className="relative flex flex-col items-start gap-6 md:flex-row md:items-center md:justify-between">
          <div className="max-w-xl">
            <div
              className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-2xl"
              style={{ backgroundColor: 'rgba(63,206,209,0.12)', color: ACCENT }}
            >
              <Smartphone size={26} />
            </div>
            <h2 className="text-2xl font-bold tracking-tight text-white sm:text-3xl">
              {t('web.component.app-download-cta.hol-dir-die')}{' '}<span className="accent-gradient-text">{t('web.component.app-download-cta.dartcloud-app')}</span>
            </h2>
            <p className="mt-2 text-gray-400">
              {t('web.component.app-download-cta.turniere-live-scores-statistiken-mehr')}
            </p>
          </div>

          <div className="flex flex-wrap gap-3">
            <a
              href={APP_STORE_URL}
              target="_blank"
              rel="noreferrer"
              className="rounded-xl border border-zinc-700 bg-black px-5 py-3 text-sm font-semibold text-white transition-all hover:-translate-y-0.5 hover:border-[#3fced1]/60"
            >
              {t('web.component.app-download-cta.app-store')}
            </a>
            <a
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noreferrer"
              className="rounded-xl bg-[#3fced1] px-5 py-3 text-sm font-semibold text-black shadow-lg shadow-[#3fced1]/25 transition-all hover:-translate-y-0.5 hover:bg-[#35b5b8]"
            >
              {t('web.component.app-download-cta.google-play')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppDownloadCta;
